export default __webpack_public_path__ + "static/media/resume.38b67fd9.pdf";